interface ContentProps {
  children: React.ReactNode
}

export const Content = (props: ContentProps) => {
  const { children } = props

  return (
    <div
      style={{
        flex: 1,
        height: 'calc(100vh - 48px)',
        marginTop: 48,
        overflowY: 'auto',
        overflowX: 'hidden',
        background: '#fff',
        position: 'relative'
      }}
    >
      {children}
    </div>
  )
}
